var render = function () {
  var _vm$festa;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "dark-theme",
    scopedSlots: _vm._u([{
      key: "contentsImmersive",
      fn: function fn() {
        return [_c('v-container', [_c('education-tabs')], 1)];
      },
      proxy: true
    }, {
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "title": "교육 · 법률지원",
            "src": "/images/sub/sub-visual-education.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('page-section', {
    staticClass: "page-section--sm page-section--first mb-n16px mb-md-n24px"
  }, _vm._l((_vm$festa = _vm.festa) === null || _vm$festa === void 0 ? void 0 : _vm$festa.youtubeLink, function (youtubeLink, index) {
    return _c('div', {
      key: index,
      staticClass: "mb-16px mb-md-24px",
      attrs: {
        "data-aos": "fade-up",
        "data-aos-delay": "100"
      }
    }, [_c('v-responsive', {
      attrs: {
        "aspect-ratio": 560 / 315
      }
    }, [_c('iframe', {
      attrs: {
        "width": "100%",
        "height": "100%",
        "src": _vm.convertYouTubeURL(youtubeLink.title),
        "title": "YouTube video player",
        "frameborder": "0",
        "allow": "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
        "allowfullscreen": ""
      }
    })])], 1);
  }), 0), _c('page-section', {
    staticClass: "page-section--sm page-section--last",
    attrs: {
      "title": "교육 프로그램"
    }
  }, [_c('u-tabs-solid', {
    staticClass: "mb--md",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    },
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, _vm._l(_vm.festa.section2, function (section, index) {
    return _c('v-tab', {
      key: index,
      on: {
        "click": function click($event) {
          return _vm.input(index);
        }
      }
    }, [_vm._v(_vm._s(section === null || section === void 0 ? void 0 : section.name))]);
  }), 1), _c('v-tabs-items', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    },
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, _vm._l(_vm.festa.section2, function (section, index) {
    return _c('v-tab-item', {
      key: index
    }, [_c('page-section', {
      staticClass: "page-section--sm pt-0"
    }, [_c('template', {
      slot: "pageSectionImmersive"
    }, [_c('table-primary', _vm._l(section.items, function (item, index) {
      return _c('v-sheet', {
        key: index
      }, [_c('v-row', {
        staticClass: "font-size-16 font-size-md-24 font-weight-regular font-pretendard",
        attrs: {
          "no-gutters": "",
          "align": "center"
        }
      }, [_c('v-col', {
        attrs: {
          "cols": "12",
          "md": "auto"
        }
      }, [_c('div', {
        staticClass: "px-12px pt-10px pl-md-0 pr-md-20px py-md-24px py-lg-40px w-md-160px"
      }, [_c('div', {
        staticClass: "font-weight-extrabold grey--text text--darken-4"
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(item.title.replace(/\n/g, '<br />'))
        }
      })])])]), _c('v-col', {
        attrs: {
          "cols": "12",
          "md": ""
        }
      }, [_c('div', {
        staticClass: "px-12px pt-4px pb-10px px-md-20px py-md-24px py-lg-40px"
      }, [_c('div', {
        staticClass: "font-size-18 font-size-md-24"
      }, [_c('p', {
        domProps: {
          "innerHTML": _vm._s(item.txt.replace(/\n/g, '<br />'))
        }
      })])])])], 1), _c('v-divider')], 1);
    }), 1)], 1)], 2), _c('page-section', {
      staticClass: "page-section--sm pb-0"
    }, [_c('template', {
      slot: "pageSectionImmersive"
    }, [_c('div', {
      staticClass: "tit-wrap"
    }, [_c('h3', {
      staticClass: "tit"
    }, [_vm._v("커리큘럼")])]), _c('div', {
      staticClass: "mb--md"
    }, _vm._l(section.curriculums, function (curriculum, index) {
      return _c('v-row', {
        key: index,
        staticClass: "row--xs"
      }, [_c('v-col', {
        attrs: {
          "cols": "auto"
        }
      }, [_c('i', {
        staticClass: "dot mt-8px mt-md-6px primary"
      })]), _c('v-col', [_c('h5', {
        staticClass: "tit tit--xxs"
      }, [_vm._v(" " + _vm._s(curriculum === null || curriculum === void 0 ? void 0 : curriculum.title) + " ")]), _vm._l(curriculum.subtitles, function (subtitle, index) {
        return _c('ul', {
          key: index,
          staticClass: "mt-12px mt-md-24px"
        }, [_c('li', {
          staticClass: "txt txt--dark"
        }, [_vm._v(" " + _vm._s(subtitle.title) + " ")]), _c('ul', {
          staticClass: "mt-6px"
        }, _vm._l(subtitle.items, function (item, index) {
          return _c('li', {
            key: index,
            staticClass: "txt mt-4px dot-txt"
          }, [_vm._v(" · " + _vm._s(item.title) + " ")]);
        }), 0)]);
      })], 2)], 1);
    }), 1), _vm._l(section === null || section === void 0 ? void 0 : section.links, function (link, index) {
      return _c('div', {
        key: index,
        staticClass: "mt-16px mt-md-24px"
      }, [_c('v-responsive', {
        attrs: {
          "aspect-ratio": 560 / 315
        }
      }, [_c('iframe', {
        staticClass: "d-block",
        attrs: {
          "width": "100%",
          "height": "100%",
          "src": _vm.convertYouTubeURL(link.title),
          "title": "YouTube video player",
          "frameborder": "0",
          "allow": "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
          "allowfullscreen": ""
        }
      })])], 1);
    }), _c('v-layout', {
      staticClass: "mt--md",
      attrs: {
        "justify-center": ""
      }
    }, [_c('v-btn', {
      staticClass: "min-w-lg-180px justify-space-between",
      attrs: {
        "href": section.link,
        "target": "_blank",
        "x-large": "",
        "color": "secondary"
      }
    }, [_vm._v(" 교육접수 바로가기 "), _c('icon-arrow-rounded', {
      staticClass: "icon--size-small ml-12px",
      attrs: {
        "direction": "right"
      }
    })], 1)], 1)], 2)], 2)], 1);
  }), 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }